import 'C:\\Projects\\genkei\\zumeco\\static\\folder\\FolderHeader.tsx.esbuild-plugin-linaria.css';
import 'C:\\Projects\\genkei\\zumeco\\static\\folder\\FolderHeader.tsx.esbuild-plugin-windicss.css';
import { css } from '@linaria/core';
import { mdiAxisZArrow, mdiCheckboxMultipleMarkedOutline, mdiDeleteOutline, mdiDownloadMultiple, mdiFilePlusOutline, mdiShareVariant } from '@mdi/js';
import { memo, useRef } from 'preact/compat';
import { COLOR_PANEL_SHADOW } from '../shared/colors';
import { cssToolbarButtonLike } from '../shared/components/cssToolbarButtonLike';
import { Icon } from '../shared/components/Icon';
import { ToolbarSwitches, ToolbarSwitchesItem } from '../shared/components/ToolbarSwitches';
import { DoodleOrder, doodleOrders, setDoodleOrder, useDoodleOrder } from '../shared/doodleOrder';
import { i18n } from '../shared/i18n';
import { withProgressBar } from '../shared/utils';
import { getCurrentUser, useCurrentUser } from './data/account';
import { DoodleGrouping, doodleGroupings, setDoodleGrouping, useDoodleGrouping } from './data/doodleGrouping';
import { FolderButton, FolderFileButton } from './FolderButton';
import { deleteSelectedDoodles, DoodleListFormat, doodleListFormats, setDoodleListFormat, setSelectedDoodles, uploadFiles, useCurrentDoodlesQuery, useCurrentFolder, useDoodleListFormat, useSelectedDoodles } from './folderState';
import { enqueuePdfDownloadDoodle } from './PdfDownloadStatusPanel';
import { ShareFolderDialog } from './ShareFolderDialog';
const StartSelectingDoodlesButton = memo(() => <FolderButton icon={mdiCheckboxMultipleMarkedOutline} text={i18n.select} onClick={() => setSelectedDoodles(doodles => doodles ? null : [])} />);
const CancelSelectingDoodlesButton = memo(() => <FolderButton icon={mdiCheckboxMultipleMarkedOutline} text={i18n.cancelSelection} onClick={() => setSelectedDoodles(null)} />);
const DownloadSelectedDoodlesPdfButton = memo(() => {
  const selectedDoodles = useSelectedDoodles();
  return <FolderButton icon={mdiDownloadMultiple} text={i18n.downloadEachPdf} disabled={!selectedDoodles?.length} inverted onClick={() => {
    const doodles = useSelectedDoodles.snapshot();
    doodles?.forEach(doodle => enqueuePdfDownloadDoodle(doodle));
  }} />;
});
const DownloadConcatenatedPdfButton = memo(() => {
  const selectedDoodles = useSelectedDoodles();
  return <FolderButton icon={mdiAxisZArrow} iconClass={"f1fx20hc"} text={i18n.downloadConcatenatedDoodles} disabled={(selectedDoodles?.length ?? 0) < 2} inverted onClick={() => {
    const doodles = useSelectedDoodles.snapshot();
    doodles?.length && enqueuePdfDownloadDoodle(doodles);
  }} />;
});
const DeleteSelectedDoodlesButton = memo(() => {
  const selectedDoodles = useSelectedDoodles();
  return <FolderButton icon={mdiDeleteOutline} text={i18n.deleteSelectedDoodles} disabled={!selectedDoodles?.length} inverted onClick={() => {
    if (!selectedDoodles) {
      return;
    }
    const uid = getCurrentUser()?.uid;
    if (!uid || selectedDoodles.some(doodle => doodle.ownerUserId !== uid)) {
      return alert(i18n.permissionDeniedForSomeDoodles);
    }
    if (confirm(i18n.confirmDeleteMany(selectedDoodles.length))) {
      void withProgressBar(() => deleteSelectedDoodles());
      setSelectedDoodles(null);
    }
  }} />;
});
const SelectDoodleGrouping = memo(() => {
  const currentFolder = useCurrentFolder();
  const doodleGrouping = useDoodleGrouping();
  if (!currentFolder?.tenantSharing) {
    return null;
  }
  return <select class={cssToolbarButtonLike} value={doodleGrouping} onChange={e => setDoodleGrouping(e.currentTarget.value as DoodleGrouping)}>
      {doodleGroupings.map(([value, label]) => <option key={value} value={value} children={label} />)}
    </select>;
});
const SelectDoodleOrder = memo(() => {
  const doodleOrder = useDoodleOrder();
  return <select class={cssToolbarButtonLike} value={doodleOrder} onChange={e => setDoodleOrder(e.currentTarget.value as DoodleOrder)}>
      {doodleOrders.map(([value, label]) => <option key={value} value={value} children={label} />)}
    </select>;
});
const doodleListFormatItems = doodleListFormats.map<ToolbarSwitchesItem<DoodleListFormat>>(([value, name, icon]) => ({
  value,
  // <IconAndText icon={icon} text={name} iconClass="w-9" />,
  children: <div title={name}>
      <Icon icon={icon} />
    </div>
}));
const SwitchDoodleListFormat = memo(() => {
  const doodleListFormat = useDoodleListFormat();
  return <div class={"dpn146c"}>
      <ToolbarSwitches name="ca874bd9aeef" items={doodleListFormatItems} selectedValue={doodleListFormat} onChange={setDoodleListFormat} />
    </div>;
});
const ShareFolderButton = memo(() => {
  const dialogRef = useRef<HTMLDialogElement>(null);
  return <>
      <FolderButton icon={mdiShareVariant} text={i18n.share} onClick={() => dialogRef.current?.showModal()} />
      <ShareFolderDialog ref={dialogRef} />
    </>;
});
export const FolderHeader = memo(() => {
  const currentUser = useCurrentUser();
  const selectedDoodles = useSelectedDoodles();
  const currentFolder = useCurrentFolder();
  const query = useCurrentDoodlesQuery();
  const currentUserIsCurrentFolderOwner = !!currentUser && currentUser.uid === currentFolder?.ownerUserId;
  return <div class="flex flex-wrap items-center min-h-44px px-6 pt-2px pb-4px gap-x-2 gap-y-1 bg-white text-sm" style={`box-shadow: 0 0 2px ${COLOR_PANEL_SHADOW}`}>
      <h3 class="text-lg mr-6">
        {query.kind === 'search' ? `${i18n.search}: ${query.where.filename?.containsAll?.join(' ') ?? ''}` : currentFolder?.name || i18n.rootFolderName}
      </h3>
      {(currentUserIsCurrentFolderOwner || !!currentFolder?.tenantSharing) && (selectedDoodles ? <>
            <div class="text-primary">{i18n.nDoodlesAreSelected(selectedDoodles.length)}</div>
            <DownloadSelectedDoodlesPdfButton />
            <DownloadConcatenatedPdfButton />
            <DeleteSelectedDoodlesButton />
            <CancelSelectingDoodlesButton />
          </> : <>
            {query.kind === 'folder' && <FolderFileButton icon={mdiFilePlusOutline} text={i18n.addDrawings} onSelectFiles={uploadFiles} />}
            <StartSelectingDoodlesButton />
          </>)}
      <div class="flex-auto flex items-center justify-end gap-2">
        {currentUserIsCurrentFolderOwner && !!currentFolder?.shared && <ShareFolderButton />}
        <SelectDoodleGrouping />
        <SelectDoodleOrder />
        <SwitchDoodleListFormat />
      </div>
    </div>;
});